/* "Read its story" (snippets/story-sheet.liquid). The <details> is the fallback and the source: without
 * this script the link opens the story in place. With it:
 *
 *   ON A PHONE (below 810px, the shop's phone edge) the story opens in the Showroom's slide-up sheet
 *   (assets/showroom-sheet.js), which owns the slide, the drag strip, Esc and the scroll lock. This adds
 *   the header with the page's name and a backdrop that closes it. No Close button (Dayton, 2026-09-27:
 *   "this massive close button that isn't needed"): the strip, the backdrop and Esc all close it.
 *
 *   ON A DESKTOP it opens under the H1, where the story stood before 2026-09-27, as the page's own prose
 *   (Dayton: "when I click read its story on desktop web, the slide up bottom sheet appears. I think the
 *   text should appear below the h1"). The link becomes "Hide its story" and closes it again. The block
 *   wears the masthead's paper, so it reads as part of the head and not a band pasted under it.
 *
 * Either way it publishes `story_open` {surface, handle}, the way the shelves publish their events.
 */
(() => {
  if (window.__storySheet) return;
  window.__storySheet = true;

  const PHONE = window.matchMedia('(max-width: 809px)');
  const CALM = window.matchMedia('(prefers-reduced-motion: reduce)');
  const track = (name, payload) => { try { window.Shopify?.analytics?.publish?.(name, payload); } catch (_) { /* never */ } };
  const opened = (d) => track('story_open', { surface: d.dataset.surface, handle: d.dataset.key, view: PHONE.matches ? 'sheet' : 'inline' });
  const bodyOf = (d) => d.querySelector('.ckg-story__body').innerHTML;

  /* ---- the phone: the sheet ---- */
  const sheets = new WeakMap();
  function sheetFor(d) {
    if (sheets.has(d)) return sheets.get(d);
    const scrim = document.createElement('div');
    scrim.className = 'sr-sheet-scrim';
    document.body.appendChild(scrim);
    const s = window.SRSheet.create({
      ariaLabel: `${d.dataset.name || 'This page'}: its story`,
      className: 'sr-sheet--story',
      onOpen: () => scrim.classList.add('is-open'),
      onClose: () => scrim.classList.remove('is-open'),
    });
    s.setContent('<div class="sr-sheet__head"><h2></h2></div>'
      + '<div class="sr-sheet__scroll"><div class="ckg-story__prose"></div></div>');
    s.body.querySelector('h2').textContent = d.dataset.name || '';
    s.body.querySelector('.ckg-story__prose').innerHTML = bodyOf(d);
    scrim.addEventListener('click', () => s.close());
    sheets.set(d, s);
    return s;
  }

  /* ---- the desktop: under the H1 ---- */
  const blocks = new WeakMap();
  function blockFor(d) {
    if (blocks.has(d)) return blocks.get(d);
    const block = document.createElement('section');
    block.className = 'pp ckg-story-inline';
    block.hidden = true;
    block.setAttribute('aria-label', `${d.dataset.name || 'This page'}: its story`);
    block.innerHTML = '<div class="pp__wrap"><div class="pp__prose pp__prose--story ckg-story-inline__prose"></div></div>';
    block.querySelector('.pp__prose').innerHTML = bodyOf(d);
    const mast = document.getElementById('ckg-h1')?.closest('section');
    if (mast) {
      const bg = getComputedStyle(mast);
      Object.assign(block.style, {
        backgroundColor: bg.backgroundColor, backgroundImage: bg.backgroundImage,
        backgroundSize: bg.backgroundSize, backgroundRepeat: bg.backgroundRepeat,
      });
      mast.after(block);
    } else {
      d.after(block);
    }
    blocks.set(d, block);
    return block;
  }
  function toggleInline(d, summary) {
    const block = blockFor(d);
    const open = block.hidden;
    block.hidden = !open;
    summary.setAttribute('aria-expanded', String(open));
    summary.querySelector('.ckg-story__label').textContent = open ? 'Hide its story' : (d.dataset.label || 'Read its story');
    summary.querySelector('.ckg-story__arrow').textContent = open ? '↑' : '→';
    if (!open) return;
    /* On a collection the link sits in the shelf's panel, below where the story opens; bring the story
       into view if it opened above the fold. Under the H1 (a destination) it opens right under the link
       and nothing moves. */
    const top = block.getBoundingClientRect().top;
    if (top < 0 || top > window.innerHeight * 0.8) block.scrollIntoView({ behavior: CALM.matches ? 'auto' : 'smooth', block: 'start' });
    opened(d);
  }

  document.addEventListener('click', (e) => {
    const summary = e.target.closest('.ckg-story > summary');
    if (!summary) return;
    const d = summary.parentElement;
    if (d.open) return; /* opened in place before this script arrived: let it close in place */
    if (PHONE.matches) {
      if (!window.SRSheet) return;
      e.preventDefault();
      sheetFor(d).open();
      opened(d);
    } else {
      e.preventDefault();
      toggleInline(d, summary);
    }
  });
})();
